class ME_FormDeclaration {
    constructor() {
        this.formRegister();
        this.formUpdate();
        this.formDeclaration();
    }

    formRegister() {
        let registerBtn = document.querySelector("#register-button");
        if (!registerBtn) {
            return
        }
        registerBtn.addEventListener('click', function (e) {
            e.preventDefault();
            let formRegisterNew = document.getElementById("form-register-conference");
            let submitEventR = new Event('submit', {
                bubbles: true,
                cancelable: true
            });
            formRegisterNew.dispatchEvent(submitEventR);
            formRegisterNew.submit();
        });
    }

    formUpdate() {
        let updateBtn = document.querySelector("#annual-update-form-btn");
        if (!updateBtn) {
            return
        }
        updateBtn.addEventListener('click', function (e) {
            e.preventDefault();
            let formUpdateNew = document.getElementById("annual-update-form");
            let submitEventU = new Event('submit', {
                bubbles: true,
                cancelable: true
            });
            formUpdateNew.dispatchEvent(submitEventU);
            formUpdateNew.submit();
        });
    }

    formDeclaration() {
        let declarationBtn = document.querySelector("#form-declaration-btn");
        if (!declarationBtn) {
            return
        }
        declarationBtn.addEventListener('click', function (e) {
            e.preventDefault();
            let formDeclarationNew = document.getElementById("form-declaration");
            let submitEventD = new Event('submit', {
                bubbles: true,
                cancelable: true
            });
            formDeclarationNew.dispatchEvent(submitEventD);
            formDeclarationNew.submit();
        });
    }
}
